export default "__VITE_ASSET__D_I3YRvf__"